import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Check } from 'lucide-vue-next';
    import { Button } from '@/components/ui/button';
    import {
        AlertDialog,
        AlertDialogTrigger,
        AlertDialogContent,
        AlertDialogHeader,
        AlertDialogTitle,
        AlertDialogDescription,
        AlertDialogFooter,
        AlertDialogCancel,
        AlertDialogAction,
    } from '@/components/ui/alert-dialog';
    import { toast } from 'vue-sonner';
    import { useI18n } from 'vue-i18n';
    import { useMutation } from '@tanstack/vue-query';
    import { usePage } from '@inertiajs/vue3';
    import { useQueryClient } from '@tanstack/vue-query';
    import axios from 'axios';
    import QueryKey from '@/enums/QueryKey';
    import type { SharedData } from '@/types';
    import { computed } from 'vue';
    
    
export default /*@__PURE__*/_defineComponent({
  __name: 'VoucherApproveAll',
  setup(__props) {

    const queryClient = useQueryClient();

    const page = usePage<SharedData>();
    const companyId = computed(() => page.props.auth.user.selected_company_id);

    const { t } = useI18n();

    const { mutate } = useMutation({
        mutationFn: (formData: { company_id: number }) =>
            axios.post(route('v2.voucher.upload.all'), formData),
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: [QueryKey.VOUCHERS, companyId.value] });

            toast.success(data.data.success);

            if (data.data.errorMessages) {
                data.data.errorMessages.forEach((error: string) => {
                    toast.error(error);
                });
            }
        },
        onError: (error) => {
            toast.error(t('forms.system_error'));
        },
    });

    function uploadAll() {
        mutate({
            company_id: companyId.value,
        });
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AlertDialog), null, {
    default: _withCtx(() => [
      _createVNode(_unref(AlertDialogTrigger), { "as-child": "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Button), {
            variant: "ghost",
            width: "narrow",
            class: "self-start",
            size: "xs"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('vouchers.approve_all')) + " ", 1),
              _createVNode(_unref(Check), { class: "text-accent" })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(AlertDialogContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(AlertDialogHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(AlertDialogTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('vouchers.approve_all')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(AlertDialogDescription), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('vouchers.js.upload_content')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(AlertDialogFooter), null, {
            default: _withCtx(() => [
              _createVNode(_unref(AlertDialogCancel), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('forms.no')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(AlertDialogAction), {
                variant: "default",
                onClick: uploadAll
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('forms.yes')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})